import { useSelector } from "react-redux";

export const useMobileMenuState = () =>
  useSelector(state => state.mobileMenu.isOpen);
